import { useEffect, useState } from 'react';

import viewOrigins from '@/shared/api/fulfilment/providerOrigins/viewOrigins';
import viewShippingProfiles from '@/shared/api/shipping/profiles/viewShippingProfiles';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import FulfilmentProviderOrigin from '@/shared/types/fulfilment/fulfilmentProviderOrigin.type';
import Order from '@/shared/types/order/order.type';
import ShippingProfile from '@/shared/types/shipping/shippingProfile.type';

type Args = {
  order: Order;
};

const useSubmitToFulfilment = ({ order }: Args) => {
  const redirectLogin = useRedirectLogin();

  const [fulfilmentProviderOrigins, setFulfilmentProviderOrigins] = useState<
    FulfilmentProviderOrigin[] | null
  >(null);

  const [shippingProfiles, setShippingProfiles] = useState<
    ShippingProfile[] | null
  >(null);

  useEffect(() => {
    const fetchFulfilmentProviderOrigins = async () => {
      const response = await viewOrigins({ onUnauthorized: redirectLogin });

      if (response.success) {
        setFulfilmentProviderOrigins(response.data);
      }
    };

    void fetchFulfilmentProviderOrigins();
  }, [redirectLogin]);

  useEffect(() => {
    const fetchShippingProfile = async () => {
      const response = await viewShippingProfiles({
        body: {
          search: [
            {
              shipping_profile_id: {
                value: order.shipping_profile_id,
              },
            },
          ],
        },
        onUnauthorized: redirectLogin,
      });

      if (response.success) {
        setShippingProfiles(response.data);
      }
    };

    void fetchShippingProfile();
  }, [order, redirectLogin]);

  return {
    fulfilmentProviderOrigins,
    shippingProfiles,
  };
};

export default useSubmitToFulfilment;
